module.exports = "<div class=\"progress-bar\">\n\t<span :style=\"style\" class=\"progress-bar-meter\"></span>\n</div>\n"